import React, {useEffect, useState} from "react";
import "./_filter-component.scss";
import MobileFilterButton from "../../atoms/search-bar-filter-components/mobile-filter-button/mobile-filter-button";
import FilterIcon from '../../assets/icons/filter-icon.svg';
import {useSelector, useDispatch} from "react-redux";
import {clubFinderMapResultSliceActions} from "../../../store/slices/clubFinderResultMapSlice";
import {RootState} from "../../../store/configureStore";
import chevron from "../../assets/icons/chevron-down.svg";
import {AppVersionForTenants} from "../../../constants/Config";

const baseClass = 'clubFinder-filter-component';

const FilterComponent = (): JSX.Element => {
  const dispatch = useDispatch();
  const selectedLocation = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedLocation);
  const selectedGenderFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedGenderFilter);
  const savedFormatFilterName: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName);
  const [selectedOptions, setSelectedOptions] = useState({
    location: '',
    for: '',
    format: '',
  });

  const isMapExpanded = useSelector((state: RootState) => state.clubFinderMapResultStore.isMapExpanded);
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const userLocationAddress = useSelector((state: RootState) => state.clubFinderSearchBarStore.userLocationAddress);

  useEffect(() => {
    let locationText = '';
    let forText = '';
    let formatText = '';
    if (selectedLocation && selectedLocation.orgName) {
      locationText = selectedLocation.orgName;
    }
    if (selectedLocation && selectedLocation.address && selectedLocation.address.suburb) {
      locationText = locationText.length > 0 ? `${locationText}, ${selectedLocation.address.suburb}` : selectedLocation.address.suburb;
    }

    if (selectedGenderFilter && selectedGenderFilter.name) {
      forText = selectedGenderFilter.name;
    }

    if (savedFormatFilterName && savedFormatFilterName.length > 1) {
      formatText = `${savedFormatFilterName[0]} + ${savedFormatFilterName.length - 1}`;
    } else if (savedFormatFilterName) {
      formatText = savedFormatFilterName[0];
    }

    setSelectedOptions({
      location: locationText,
      for: forText,
      format: formatText,
    });

    if (userLocationAddress && userLocationAddress.suburb && AppVersionForTenants.v2.tenants.includes(tenant)) {
      let inputValue = "";

      if (userLocationAddress.route) {
        if (inputValue) {
          inputValue += " ";
        }
        inputValue += userLocationAddress.route;
      }

      if (userLocationAddress.suburb) {
        if (inputValue) {
          inputValue += ", ";
        }
        inputValue += userLocationAddress.suburb;
      }

      if (userLocationAddress.state) {
        if (inputValue) {
          inputValue += " ";
        }
        inputValue += userLocationAddress.state;
      }
      setSelectedOptions({
        location: inputValue,
        for: '',
        format: '',
      });
    }
  }, [selectedLocation, selectedGenderFilter, savedFormatFilterName, userLocationAddress, tenant]);

  const expandMap = () => {
    dispatch(clubFinderMapResultSliceActions.setIsMapExpanded(!isMapExpanded));
  }

  return (
    <div className={`${baseClass}`}>
      <div className={`${baseClass}--map-toggle ${isMapExpanded ? baseClass+'--map-toggle--expanded' : baseClass+'--map-toggle--collapsed'}`} onClick={expandMap}>
        <img src={chevron} alt={'Toggle Map'}/>
      </div>
      <div className={`${baseClass}--filterContainer`}>
        <MobileFilterButton location={selectedOptions.location} format={selectedOptions.format} for={selectedOptions.for} tenant={tenant}/>
        {/*TODO: Bring back the filter once ready to implement*/}
        {false && <div className={'filterText'}>
          <img src={FilterIcon} className={'filterIcon'} alt="logo"/>
          Filter
        </div>}
      </div>
    </div>
  )
}

export default FilterComponent;
